import { projectsAPI } from 'api/projects/endpoints';
import { mutateProjectsUsefulLinks } from 'fetchers/mutations/mutateProjectsUsefulLinks';

export const removeUsefulLink = async (projectId: string, linkId: string) => {
  await projectsAPI.removeProjectsUsefulLink(projectId, linkId);
  await mutateProjectsUsefulLinks();
};
